

































































import { defineComponent, ref, onMounted, onUnmounted, watch, nextTick } from '@vue/composition-api'
import JsBarcode from 'jsbarcode'
import dayjs from 'dayjs'
import useDisplayDependingOnLang from '@/components/hook/useDisplayDependingOnLang'

/**
 * マイページ: 会員証 現在時刻表示パーツ
 */
export default defineComponent({
  name: 'CurrentTimeParts',
  props: {
    hashedUserId: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { getDisplayDate } = useDisplayDependingOnLang()
    const barcodeRef = ref(null)

    /**
     * 現在時刻を取得
     * dayjs使用 YYYY/MM/DD hh:mm:ss 形式
     * @returns 現在時刻
     */
    const getCurrentTime = () =>
      getDisplayDate(dayjs().valueOf(), 'YYYY/MM/DD HH:mm:ss', 'MMM DD, YYYY HH:mm:ss')
    const currentTime = ref<string>(getCurrentTime())

    let currentTimeTimer: number

    onMounted(() => {
      currentTime.value = getCurrentTime()

      currentTimeTimer = window.setInterval(() => {
        currentTime.value = getCurrentTime()
      }, 1000)
    })

    watch(
      () => props.hashedUserId,
      () => {
        nextTick(() => {
          if (barcodeRef.value && props.hashedUserId) {
            JsBarcode(barcodeRef.value, props.hashedUserId, {
              format: 'CODE128',
              lineColor: '#000000',
              width: 2,
              height: 50,
              fontSize: 15,
              textMargin: 2,
              displayValue: true,
            })
          }
        })
      },
      { immediate: true },
    )

    onUnmounted(() => {
      clearInterval(currentTimeTimer)
    })

    return {
      currentTime,
      barcodeRef,
    }
  },
})
